import { Link } from 'react-router-dom';
import { useEnquiryModal } from '@/hooks/useEnquiryModal';

export default function HeroSection() {
  const { openEnquiry } = useEnquiryModal();
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/images/home-hero.jpg"
          alt="Fresh fruits and vegetables supply – Bassi Enterprises Shamli fresh produce supplier"
          title="Bassi Enterprises – Fresh Fruits & Vegetables Supplier Shamli Uttar Pradesh"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-block px-4 py-1.5 bg-primary-500/90 text-background-50 text-xs md:text-sm font-medium rounded-full mb-5 md:mb-6">
            B2B Fresh Produce Supplier
          </span>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4 md:mb-6">
            Fresh Fruits & Vegetables Supplier for Businesses
          </h1>

          <p className="text-background-50/80 text-sm md:text-lg max-w-2xl mx-auto mb-7 md:mb-9 leading-relaxed">
            Reliable bulk supply of quality produce with consistent availability and professional service. Trusted partner for quick-commerce, restaurants, hotels, and retailers across India.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <button
              onClick={() => openEnquiry()}
              className="inline-flex items-center gap-2 px-6 py-3 md:px-8 md:py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-primary-400 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              <i className="ri-whatsapp-fill text-lg md:text-xl"></i>
              Request Bulk Supply Quote
            </button>
            <a
              href="tel:+919084756574"
              className="inline-flex items-center gap-2 px-6 py-3 md:px-8 md:py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/20"
            >
              <i className="ri-phone-fill text-lg"></i>
              Call Now
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-background-50/60 text-xl"></i>
        </div>
      </div>
    </section>
  );
}